import TextInput from 'common/components/inputs/text/TextInput';
import useToggle from 'common/hooks/useToggle';
import React from 'react';
import { Button, FormGroup, FormLabel } from 'react-bootstrap';

interface IPasswordInput {
  onChange: (value: string) => void;
  error: string | undefined;
}

const PasswordInput = (props: IPasswordInput) => {
  const [showPassword, toggleShowPassword] = useToggle(false);
  return (
    <FormGroup>
      <FormLabel htmlFor='password'>Password</FormLabel>
      <TextInput
        id='password'
        name='password'
        type={showPassword ? 'text' : 'password'}
        autoComplete='current-password'
        onChange={(e) => {
          e.preventDefault();
          const { value } = e.target;
          props.onChange(value);
        }}
        error={props.error}
      />
      <Button
        type='button'
        color='primary'
        className='form-text float-right'
        variant='link'
        size='sm'
        onClick={toggleShowPassword}
      >
        {showPassword ? 'Hide password' : 'Show password'}
      </Button>
    </FormGroup>
  );
};

export default PasswordInput;
